import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {Checkbox, FormControlLabel, InputAdornment, Typography} from "@mui/material";
import React, {Fragment, useState} from "react";
import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Input from '@mui/material/Input';
import './LoginRegister.css'

type Props = {
    loadUser: (arg: boolean) => void
}
export default function LoginRegister({loadUser}: Props) {

    const [loginemail, setloginemail] = useState('');
    const [loginpassword, setloginpassword] = useState('');
    const [showloginpassword, setshowloginpassword] = useState(false);
    const [loginresult, setloginresult] = useState('')
    const [registeremail, setregisteremail] = useState('');
    const [registername, setregistername] = useState('');
    const [registerpassword, setregisterpassword] = useState('');
    const [registerpasswordr, setregisterpasswordr] = useState('');
    const [showregisterpassword, setshowregisterpassword] = useState(false);
    const [showregisterpasswordr, setshowregisterpasswordr] = useState(false);

    const [registersl, setregistersl] = useState(false);
    const [registerresult, setregisterresult] = useState('')
    const [loading, setloading] = useState(false)

    const login = () => {
        setloading(true)
        setloginresult('')
        fetch(apiAddress + "/users/login", createOptions('POST', {
                email: loginemail,
                password: loginpassword
            })
        ).then((res) => res.json()).then((data) => {
            console.log('then', data)
            if (data.hasOwnProperty('user')) {
                localStorage.setItem('user', JSON.stringify(data.user));
                loadUser(true);
            }
            if (data.hasOwnProperty('msg')) {
                setloginresult(data.msg);
                setloading(false);
            }
            if (data.hasOwnProperty('error')) {
                let err = data?.err?.code;
                setloginresult(data.error + ' ' + err);
                setloading(false);
            }
        }).catch((exeption) => {
            console.log('login catch', exeption)
            setloginresult('login failed (exeption)');
            setloading(false);
        });
    }

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^\S*@\S*\.\S*$/
            );
    };

    const register = () => {
        if (registerpassword !== registerpasswordr) {
            alert('pw falsch');
            return;
        }
        if (!validateEmail(registeremail)) {
            alert('email fehlt oder fehlerhaft');
            return;
        }
        setloading(true)
        setregisterresult('')
        fetch(apiAddress + "/users/register", createOptions('POST', {
                email: registeremail,
                name: registername,
                password: registerpassword,
                sl: registersl
            })
        ).then((res) => res.json()).then((data) => {
            setloading(false);
            console.log('register', data)
            if (data.hasOwnProperty('user')) {
                localStorage.setItem('user', JSON.stringify(data.user));
                loadUser(true);
            }
            if (data.hasOwnProperty('msg')) setregisterresult(data.msg);
            if (data.hasOwnProperty('errors') && Array.isArray(data.errors)) setregisterresult(data.errors.map(e => e.msg).join(', '));
            if (data.hasOwnProperty('error') && data.error instanceof Object) setregisterresult(JSON.stringify(data.error));
        });
    }

    return <Fragment>
        <Paper style={{marginTop: 20}}>
            <Grid container spacing={1} style={{padding: 10}}>
                <Grid item xs={12}><Typography variant="h4">Login</Typography></Grid>
                <Grid item xs={12} md={4}>
                    <FormControl variant="standard" style={{width: '100%'}}>
                        <InputLabel>E-Mail</InputLabel>
                        <Input type={'email'} onChange={e => setloginemail(e.target.value)}
                               value={loginemail}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl variant="standard" style={{width: '100%'}}>
                        <InputLabel>Password</InputLabel>
                        <Input onChange={e => setloginpassword(e.target.value)}
                               value={loginpassword}
                               type={showloginpassword ? 'text' : 'password'}
                               endAdornment={
                                   <InputAdornment position="end">
                                       <IconButton
                                           aria-label="toggle password visibility"
                                           onClick={() => setshowloginpassword(!showloginpassword)}
                                           edge="end"
                                       >
                                           {showloginpassword ? <VisibilityOff/> : <Visibility/>}
                                       </IconButton>
                                   </InputAdornment>
                               }
                        />
                    </FormControl>
                </Grid>
                <Grid item md={2} xs={0}></Grid>
                <Grid item xs={12} md={2}>
                    <FormControl variant="standard" style={{width: '100%', alignItems: 'center'}}>
                        <Button onClick={login}>Anmelden</Button>
                    </FormControl>
                </Grid>
                {loading ? <Grid item xs={12}> <span className={'loading'}>loading...</span></Grid> : null}
                {loginresult ? <Grid item xs={12}> <span className={'result'}>{loginresult}</span></Grid> : null}
            </Grid>
        </Paper>
        <Paper style={{marginTop: 20}}>
            <Grid container spacing={1} style={{padding: 10}}>
                <Grid item xs={12}><Typography variant="h4">Registrierung</Typography></Grid>
                <Grid item xs={12} md={4}>
                    <FormControl variant="standard" style={{width: '100%'}}>
                        <InputLabel>E-Mail</InputLabel>
                        <Input onChange={e => setregisteremail(e.target.value)}
                               value={registeremail}
                               type='email'
                        />
                    </FormControl>
                    <FormControl variant="standard" style={{width: '100%'}}>
                        <InputLabel>Name</InputLabel>
                        <Input onChange={e => setregistername(e.target.value)}
                               value={registername}
                               type='text'
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                    <FormControl variant="standard" style={{width: '100%'}}>
                        <InputLabel>Password </InputLabel>
                        <Input onChange={e => setregisterpassword(e.target.value)}
                               value={registerpassword}
                               type={showregisterpassword ? 'text' : 'password'}
                               endAdornment={
                                   <InputAdornment position="end">
                                       <IconButton
                                           aria-label="toggle password visibility"
                                           onClick={() => setshowregisterpassword(!showregisterpassword)}
                                           edge="end"
                                       >
                                           {showregisterpassword ? <VisibilityOff/> : <Visibility/>}
                                       </IconButton>
                                   </InputAdornment>
                               }
                        />
                    </FormControl>
                    <FormControl variant="standard" style={{width: '100%'}}>
                        <InputLabel>Password wiederholen</InputLabel>
                        <Input onChange={e => setregisterpasswordr(e.target.value)}
                               value={registerpasswordr}
                               type={showregisterpasswordr ? 'text' : 'password'}
                               endAdornment={
                                   <InputAdornment position="end">
                                       <IconButton
                                           aria-label="toggle password visibility"
                                           onClick={() => setshowregisterpasswordr(!showregisterpasswordr)}
                                           edge="end"
                                       >
                                           {showregisterpasswordr ? <VisibilityOff/> : <Visibility/>}
                                       </IconButton>
                                   </InputAdornment>
                               }
                        />
                    </FormControl>
                </Grid>
                <Grid item md={2} xs={12}>
                    <FormControl variant="standard" style={{width: '100%', alignItems: 'center'}}>
                        <FormControlLabel
                            label="SL?"
                            control={
                                <Checkbox checked={registersl || false}
                                          onChange={
                                              (e) => setregistersl(e.target.checked)
                                          }/>
                            }/>
                    </FormControl>
                </Grid>
                <Grid item md={2} xs={12} style={{alignItems: 'center'}}>
                    <FormControl variant="standard" style={{width: '100%', alignItems: 'center'}}>
                        <Button onClick={register}>Registrieren</Button>
                    </FormControl>
                </Grid>
                {loading ? 'loading...' : null}
                {registerresult ? <Grid item xs={12}>
                    {registerresult}
                </Grid> : null}
            </Grid>
        </Paper>
    </Fragment>
}